import React from "react";
import ReactDOM from "react-dom";

const AppModal = ({
  isOpen,
  onClose,
  title = "",
  children,
  primaryLabel,
  secondaryLabel,
  onPrimary,
  onSecondary,
  primaryColor = "saveButton",
  secondaryColor = "backButton",
  disablePrimary = false,
  disableSecondary = false,
  closeOnOverlayClick = true,
  width = "40%",
  size = "md",
  headerActions = null,
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (closeOnOverlayClick && onClose) onClose();
  };

  const handleSecondaryClick = () => {
    if (onSecondary) onSecondary();
    else if (onClose) onClose();
  };

  const modalWidth = size === "lg" ? "80%" : size === "sm" ? "30%" : width;

  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          padding: 24,
          borderRadius: 8,
          minWidth: 320,
          maxWidth: "90%",
          width: modalWidth,
          maxHeight: "90vh",
          overflowY: "auto",
          boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        }}
      >
        {title ? (
          <div className="d-flex justify-content-between align-items-center border-b border-brandRed pb-2 mb-4 px-2">
            <h4 className="text-brandRed font-bold mb-0">
              {title}
            </h4>
            {headerActions}
          </div>
        ) : null}

        <div className="mt-1">{children}</div>

        {(primaryLabel || secondaryLabel) && (
          <div className="flex justify-end gap-2 mt-6">
            {secondaryLabel && (
              <button
                type="button"
                onClick={handleSecondaryClick}
                className={secondaryColor}
                disabled={disableSecondary}
                onMouseDown={(e) => e.preventDefault()}
              >
                {secondaryLabel}
              </button>
            )}
            {primaryLabel && (
              <button
                type="button"
                onClick={onPrimary}
                className={primaryColor}
                disabled={disablePrimary}
                onMouseDown={(e) => e.preventDefault()}
              >
                {primaryLabel}
              </button>
            )}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default AppModal;
